/**
 * Generated by orval v6.10.3 🍺
 * Do not edit manually.
 * CMS-POC WebAPI
 * OpenAPI spec version: 1.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  TranslationInfo,
  ErrorInfo,
  PostTranslationsDivertLanguageSyncBody,
  GetTranslationsCheckImportXml200,
  PostTranslationsImportXml200,
  PostTranslationsImportXmlBody,
  BinaryFile,
  PostTranslationsExportXmlBody,
  PostTranslationHistoryDownloadXmlBody
} from '.././model'


/**
 * 指定された制作管理IDに紐づく翻訳情報

 * @summary 翻訳情報
 */
export const getTranslations = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TranslationInfo>> => {
    return axios.get(
      `/translations/${productionId}`,options
    );
  }


export const getGetTranslationsQueryKey = (productionId: number,) => [`/translations/${productionId}`];

    
export type GetTranslationsQueryResult = NonNullable<Awaited<ReturnType<typeof getTranslations>>>
export type GetTranslationsQueryError = AxiosError<ErrorInfo>

export const useGetTranslations = <TData = Awaited<ReturnType<typeof getTranslations>>, TError = AxiosError<ErrorInfo>>(
 productionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTranslations>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTranslationsQueryKey(productionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTranslations>>> = ({ signal }) => getTranslations(productionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getTranslations>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * ベース言語同期を実行する。

 * @summary ベース言語同期
 */
export const postTranslationsBaseLanguageSync = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TranslationInfo>> => {
    return axios.post(
      `/translations/baseLanguageSync/${productionId}`,undefined,options
    );
  }



    export type PostTranslationsBaseLanguageSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postTranslationsBaseLanguageSync>>>
    
    export type PostTranslationsBaseLanguageSyncMutationError = AxiosError<ErrorInfo>

    export const usePostTranslationsBaseLanguageSync = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTranslationsBaseLanguageSync>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTranslationsBaseLanguageSync>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postTranslationsBaseLanguageSync(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postTranslationsBaseLanguageSync>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 流用他言語同期を実行する。

 * @summary 流用他言語同期
 */
export const postTranslationsDivertLanguageSync = (
    productionId: number,
    postTranslationsDivertLanguageSyncBody: PostTranslationsDivertLanguageSyncBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TranslationInfo>> => {
    return axios.post(
      `/translations/divertLanguageSync/${productionId}`,
      postTranslationsDivertLanguageSyncBody,options
    );
  }



    export type PostTranslationsDivertLanguageSyncMutationResult = NonNullable<Awaited<ReturnType<typeof postTranslationsDivertLanguageSync>>>
    export type PostTranslationsDivertLanguageSyncMutationBody = PostTranslationsDivertLanguageSyncBody
    export type PostTranslationsDivertLanguageSyncMutationError = AxiosError<ErrorInfo>

    export const usePostTranslationsDivertLanguageSync = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTranslationsDivertLanguageSync>>, TError,{productionId: number;data: PostTranslationsDivertLanguageSyncBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTranslationsDivertLanguageSync>>, {productionId: number;data: PostTranslationsDivertLanguageSyncBody}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postTranslationsDivertLanguageSync(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postTranslationsDivertLanguageSync>>, TError, {productionId: number;data: PostTranslationsDivertLanguageSyncBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 他言語画像差替えを実行する。

 * @summary 他言語画像差替え
 */
export const postTranslationsOtherLanguageIllustReplace = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<TranslationInfo>> => {
    return axios.post(
      `/translations/otherLanguageIllustReplace/${productionId}`,undefined,options
    );
  }



    export type PostTranslationsOtherLanguageIllustReplaceMutationResult = NonNullable<Awaited<ReturnType<typeof postTranslationsOtherLanguageIllustReplace>>>
    
    export type PostTranslationsOtherLanguageIllustReplaceMutationError = AxiosError<ErrorInfo>

    export const usePostTranslationsOtherLanguageIllustReplace = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTranslationsOtherLanguageIllustReplace>>, TError,{productionId: number}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTranslationsOtherLanguageIllustReplace>>, {productionId: number}> = (props) => {
          const {productionId} = props ?? {};

          return  postTranslationsOtherLanguageIllustReplace(productionId,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postTranslationsOtherLanguageIllustReplace>>, TError, {productionId: number}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 翻訳Xmlインポート前の確認

 * @summary 翻訳Xmlインポート前の確認
 */
export const getTranslationsCheckImportXml = (
    productionId: number, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetTranslationsCheckImportXml200>> => {
    return axios.get(
      `/translations/checkImportXml/${productionId}`,options
    );
  }


export const getGetTranslationsCheckImportXmlQueryKey = (productionId: number,) => [`/translations/checkImportXml/${productionId}`];

    
export type GetTranslationsCheckImportXmlQueryResult = NonNullable<Awaited<ReturnType<typeof getTranslationsCheckImportXml>>>
export type GetTranslationsCheckImportXmlQueryError = AxiosError<ErrorInfo>

export const useGetTranslationsCheckImportXml = <TData = Awaited<ReturnType<typeof getTranslationsCheckImportXml>>, TError = AxiosError<ErrorInfo>>(
 productionId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getTranslationsCheckImportXml>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetTranslationsCheckImportXmlQueryKey(productionId);

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTranslationsCheckImportXml>>> = ({ signal }) => getTranslationsCheckImportXml(productionId, { signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof getTranslationsCheckImportXml>>, TError, TData>(queryKey, queryFn, {enabled: !!(productionId), ...queryOptions}) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

/**
 * 翻訳Xmlファイルをインポートする。オプションで対象の翻訳原稿IDを指定可能。

 * @summary 翻訳Xmlインポート
 */
export const postTranslationsImportXml = (
    productionId: number,
    postTranslationsImportXmlBody: PostTranslationsImportXmlBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<PostTranslationsImportXml200>> => {const formData = new FormData();
if(postTranslationsImportXmlBody.comment !== undefined) {
 formData.append('comment', postTranslationsImportXmlBody.comment)
 }
if(postTranslationsImportXmlBody['files[]'] !== undefined) {
 postTranslationsImportXmlBody['files[]'].forEach(value => formData.append('files[]', value));
 }

    return axios.post(
      `/translations/importXml/${productionId}`,
      formData,options
    );
  }



    export type PostTranslationsImportXmlMutationResult = NonNullable<Awaited<ReturnType<typeof postTranslationsImportXml>>>
    export type PostTranslationsImportXmlMutationBody = PostTranslationsImportXmlBody
    export type PostTranslationsImportXmlMutationError = AxiosError<ErrorInfo>

    export const usePostTranslationsImportXml = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTranslationsImportXml>>, TError,{productionId: number;data: PostTranslationsImportXmlBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTranslationsImportXml>>, {productionId: number;data: PostTranslationsImportXmlBody}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postTranslationsImportXml(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postTranslationsImportXml>>, TError, {productionId: number;data: PostTranslationsImportXmlBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 翻訳Xmlファイルをエクスポートする。オプションで対象の翻訳原稿IDを指定可能。

 * @summary 翻訳Xmlエクスポート
 */
export const postTranslationsExportXml = (
    productionId: number,
    postTranslationsExportXmlBody: PostTranslationsExportXmlBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/translations/exportXml/${productionId}`,
      postTranslationsExportXmlBody,options
    );
  }



    export type PostTranslationsExportXmlMutationResult = NonNullable<Awaited<ReturnType<typeof postTranslationsExportXml>>>
    export type PostTranslationsExportXmlMutationBody = PostTranslationsExportXmlBody
    export type PostTranslationsExportXmlMutationError = AxiosError<ErrorInfo>

    export const usePostTranslationsExportXml = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTranslationsExportXml>>, TError,{productionId: number;data: PostTranslationsExportXmlBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTranslationsExportXml>>, {productionId: number;data: PostTranslationsExportXmlBody}> = (props) => {
          const {productionId,data} = props ?? {};

          return  postTranslationsExportXml(productionId,data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postTranslationsExportXml>>, TError, {productionId: number;data: PostTranslationsExportXmlBody}, TContext>(mutationFn, mutationOptions)
    }
    /**
 * 指定された翻訳履歴IDに紐づく翻訳XMLファイルをダウンロードする。

 * @summary 翻訳XMLダウンロード
 */
export const postTranslationHistoryDownloadXml = (
    postTranslationHistoryDownloadXmlBody: PostTranslationHistoryDownloadXmlBody, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<BinaryFile>> => {
    return axios.post(
      `/translations/histories/downloadXml`,
      postTranslationHistoryDownloadXmlBody,options
    );
  }



    export type PostTranslationHistoryDownloadXmlMutationResult = NonNullable<Awaited<ReturnType<typeof postTranslationHistoryDownloadXml>>>
    export type PostTranslationHistoryDownloadXmlMutationBody = PostTranslationHistoryDownloadXmlBody
    export type PostTranslationHistoryDownloadXmlMutationError = AxiosError<ErrorInfo>

    export const usePostTranslationHistoryDownloadXml = <TError = AxiosError<ErrorInfo>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postTranslationHistoryDownloadXml>>, TError,{data: PostTranslationHistoryDownloadXmlBody}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postTranslationHistoryDownloadXml>>, {data: PostTranslationHistoryDownloadXmlBody}> = (props) => {
          const {data} = props ?? {};

          return  postTranslationHistoryDownloadXml(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof postTranslationHistoryDownloadXml>>, TError, {data: PostTranslationHistoryDownloadXmlBody}, TContext>(mutationFn, mutationOptions)
    }
    